<style>
.table__container--panel {
  background-color: #f5f7f7;
  color: #757575;
  border: 1px 1px 0px 1px solid #bdc3c7;
  border-width: 1px 1px 0px 1px;
  border-style: solid;
  border-color: rgb(189, 195, 199);
}
.table__container--separator {
  border-right: 1px solid rgba(189, 195, 199, 0.5);
  content: " ";
  height: 8px;
  margin-top: 8px;
  position: relative;
  right: 0;
  top: 0;
}
.table__container--panel p {
  font-size: 12px;
}
.table__container--filter {
  font-size: 12px;
  margin: 3px;
  border: 1px solid rgba(189, 195, 199, 0.5);
}
</style>

<template>
  <v-layout
    row
    fill-height
    wrap
  >
    <ExportTableData
      ref="pobierz"
      :column-defs="columnDefs"
      :grid-options="gridOptions"
    ></ExportTableData>
    <v-layout
      class="table__container--panel"
      wrap
    >
      <v-icon
        style="padding-left: 10px"
        title="Pobierz"
        @click="'pobierz' in $refs && $refs.pobierz.showExportMenu($event)"
      >description</v-icon>

      <v-icon
        @click="$emit('removeFilters')"
        title="Usuń filtry"
      >cancel</v-icon>
      <v-layout
        align-right
        justify-end
      >
        <div style="margin-top: auto; margin-bottom: auto;">
          <p style="line-height:29px">Liczba wyników: {{numberFiltered}}/{{numberAll}}</p>
        </div>
        <input
          type="text"
          class="table__container--filter"
          v-model="filter"
          placeholder="Treść filtra"
        >
      </v-layout>
      <div class="table__container--separator"></div>
    </v-layout>
    <ag-grid-vue
      style="width: 100%; min-height:200px"
      class="ag-theme-balham"
      :gridOptions="gridOptions"
    ></ag-grid-vue>
  </v-layout>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import ExportTableData from "../../../shared/ExportTableData";

export default {
  name: "App",
  props: {
    currentChange: Object
  },
  data: () => ({
    tableTitle: "SingleChangeTable",
    date_now: new Date(),
    filter: "",
    numberAll: 0,
    numberFiltered: 0,
    rowData: []
  }),
  components: {
    AgGridVue,
    ExportTableData
  },
  watch: {
    filter(nV) {
      this.gridOptions.api.setQuickFilter(nV);
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length;
    }
  },
  computed: {
    gridOptions() {
      let gridOptions = {
        rowData: this.rowData,
        overlayLoadingTemplate:
          '<span class="ag-overlay-loading-center">Trwa ładowanie danych</span>',
        columnDefs: this.columnDefs,
        enableSorting: "true",
        enableFilter: "true",
        enableColResize: "true",
        onGridReady: this.onGridReady,
        onFilterModified: this.filteredNumber,
        onColumnMoved: this.onColumnMoved,
        onColumnResized: this.onColumnMoved,
        onFilterChanged: this.filterColumn,
        rowSelection: "multiple",
        context: {
          componentParent: this
        },
        localeText: {
          contains: "Zawiera",
          notContains: "Nie zawiera",
          lessThan: "Mniejsza niż",
          greaterThan: "Większa niż",
          equals: "Równa się",
          notEqual: "Nie równa się",
          startsWith: "Zaczyna się",
          endsWith: "Kończy się",
          noRowsToShow: "Brak danych"
        },
        getNodeChildDetails: function (parent) {
          if(parent.attributes) {
            return {
              group: true,
              children: parent.attributes,
              expanded: true
            };
          } else {
            return null;
          }
        }
      };
      return gridOptions;
    },
    activeModals() {
      return this.$store.getters.getModalsList;
    }
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "Warstwa",
        field: "layer_name"
      },
      {
        headerName: "ID obiektu",
        field: "feature",
        cellRenderer: "agGroupCellRenderer"
      },
      {
        headerName: "Rodzaj zmiany",
        field: "type",
        valueFormatter: this.translateKey
      },
      {
        headerName: "Edytowane pole",
        field: "field_name",
        valueFormatter: this.nullValue
      },
      {
        headerName: "Stara geometria",
        field: "geometry_old",
        valueFormatter: this.nullValueGeometry
      },
      {
        headerName: "Nowa geometria",
        field: "geometry_new",
        valueFormatter: this.nullValueGeometry
      },
      {
        headerName: "Obecna wartość",
        field: "is",
        valueFormatter: this.nullValue
      },
      {
        headerName: "Poprzednia wartość",
        field: "was",
        valueFormatter: this.nullValue
      }
    ];
    this.rowData = this.currentChange.changes;
  },
  methods: {
    filterColumn() {
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length.toString();
    },
    nullValue(params) {
      if(params.data.hasOwnProperty("field")) {
        if(!params.value) {
          params.value = "Brak wartości";
          return params.value;
        } else {
          return params.value;
        }
      }
    },
    nullValueGeometry(params) {
      if(params.data.hasOwnProperty("field")) {
        if(!params.value) {
          params.value = "Brak zmiany geometrii";
          return params.value;
        } else {
          return params.value;
        }
      } else {
        return '';
      }
    },
    translateKey(params) {
      let mapKey = {
        insert: "Dodanie",
        update: "Aktualizacja",
        delete: "Usunięto"
      };
      if(params.data.hasOwnProperty("type")) {
        if(!params.value) {
          params.value = "Brak wartości";
          return params.value;
        } else {
          return mapKey[params.value];
        }
      }
    },
    filteredNumber() {
      this.numberFiltered = this.gridOptions.api.getModel().getRowCount();
    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    onColumnMoved(params) {
      const columnState = JSON.stringify(
        this.gridOptions.columnApi.getColumnState()
      );
      localStorage[this.tableTitle] = columnState;
    },
    onGridReady(params) {
      if(localStorage[this.tableTitle]) {
        const columnState = JSON.parse(localStorage[this.tableTitle]);
        if(columnState) {
          this.gridOptions.columnApi.setColumnState(columnState);
        }
      }
    },
    refreshGrid(data) {
      this.gridOptions.api.setRowData(data.changes);
      this.numberAll = data.changes.length;
      this.numberFiltered = this.numberAll;
    },
    removeFilters() {
      this.gridOptions.api.setFilterModel(null);
      this.filteredNumber();
      this.filter = "";
    }
  },
  mounted() {
    this.$on("removeFilters", this.removeFilters);
    this.$root.$on("refreshSingleChangeGrid", this.refreshGrid);
    this.numberAll = this.currentChange.changes.length;
    this.numberFiltered = this.numberAll;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/table/history/SingleChangeTable.vue